import type React from "react";
import {Tag} from "~/components/tag/Tag";

/** A staged-table citation (e.g. `stg_erp_invoices_….col_12`). */
export const PtV2Citation: React.FC<{children: string; title?: string}> = ({children, title}) => (
    <Tag className="ptv2-cite" variant="outlined" color="default" label={children}
         title={title ?? 'Staged table in the workstream'}/>
);
